import { connectSpaceOrderName } from './connectSpaceOrderName';
import { SpaceOrderName as SpaceOrderNamePure } from './SpaceOrderName';

export const SpaceOrderName = connectSpaceOrderName(SpaceOrderNamePure);
